/**
 * @description Идентификатор состояния количества активных задач.
 * @type {string}
 */
export const ACTIVE_TASK_COUNT = 'ACTIVE_TASK_COUNT';

/**
 * @description Идентификатор автора задачи для фильтра задач.
 * @type {string}
 */
export const FILTER_TASK_AUTHOR_ID = 'FILTER_TASK_AUTHOR_ID';

/**
 * @description Идентификатор исполнителя задачи для фильтра задач.
 * @type {string}
 */
export const FILTER_TASK_PERFORMER_ID = 'FILTER_TASK_PERFORMER_ID';
